var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEndUserAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Avatar User Missing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "[[M]]-Business",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat",
    transform: "translate(-17.000000, -223.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(17.000000, 223.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar-User-Missing"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E1EAED",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo",
    mask: "url(#mask-2)",
    fill: "#ABBFC6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 12.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1399318,7.5025 C11.1399318,8.5625 10.2838409,9.4225 9.22865909,9.4225 C8.17347727,9.4225 7.31738636,8.5625 7.31738636,7.5025 C7.31738636,6.4425 8.17347727,5.5825 9.22865909,5.5825 C10.2838409,5.5825 11.1399318,6.4425 11.1399318,7.5025 Z M12.4265568,7.6125 C12.4265568,5.225 10.5003523,3.29 8.12370455,3.29 C5.74705682,3.29 3.82085227,5.225 3.82085227,7.6125 C3.82085227,10 5.74705682,11.935 8.12370455,11.935 C10.5003523,11.9325 12.4265568,9.9975 12.4265568,7.6125 Z M15.5771705,7.6125 C15.5771705,11.065 13.2502955,13.97 10.08475,14.835 L8.78070455,16.4225 C8.43976136,16.8375 7.80764773,16.8375 7.46670455,16.4225 L6.16514773,14.835 C2.99960227,13.97 0.672727273,11.065 0.672727273,7.6125 C0.672727273,3.4775 4.00998864,0.125 8.12370455,0.125 C12.2399091,0.125 15.5771705,3.4775 15.5771705,7.6125 Z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndUserAvatar);
export default __webpack_public_path__ + "static/media/endUserAvatar.584e2875d8981ea41c2e9d9c7148b677.svg";
export { ForwardRef as ReactComponent };